import * as React from 'react';
import IPlanTemplate from './IPlanTemplate';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../components/common/DeleteButton';

interface PlanTemplateListRowProps {
    planTemplate: IPlanTemplate;
    key: number;
    delete: (id: number) => void;
    edit: (planTemplate: IPlanTemplate) => void;
}

const PlanTemplateListRow = (props: PlanTemplateListRowProps) => {
    return (
        <tr key={props.planTemplate.id}>
            <td>{props.planTemplate.name}</td>
            <td>
                <ButtonToolbar className="pull-right">
                    <DeleteButton
                        onDelete={() => {
                            props.delete(props.planTemplate.id);
                        }}
                        text={Translate('plan-templates/list/row/delete/remove-this-plan-template')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('plan-templates/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button
                        onClick={() => {
                            props.edit(props.planTemplate);
                        }}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('plan-templates/list/row/button-label/edit')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default PlanTemplateListRow;
